/**
 * @author thanhtq
 * @version 16/11/2022
 */

/**
 *
 * @param that
 * @param router
 * @returns {boolean|string|*}
 */
export const isRouter = function (that, router) {
    let userInfo = JSON.parse(localStorage.getItem('userInfo') || {});
    if (userInfo.userRole === 'organization') return true;
    let groupMenuPermissions = that.$store.state.permissionsInfo.map(x => x.functionScreenPrefix);
    return groupMenuPermissions.find(x => x === router);
}

/**
 *
 * @param that
 * @param apiPrefix
 * @returns {boolean|string|*}
 */
export const isAPI = function (that, apiPrefix) {
    let userInfo = JSON.parse(localStorage.getItem('userInfo') || {});
    if (userInfo.userRole === 'organization') return true;
    let groupMenuPermissions = JSON.parse(localStorage.getItem('permissions')).map(x => x.functionName);
    return groupMenuPermissions.find(x => x === apiPrefix);
}
